import React from 'react';
import Typography from 'apollo-react/components/Typography';
import StyledTabs from '../../../components/common/StyledTabs/StyledTabs';
import styles from './Profile.module.css';

/**
 * @param {{ tabsVariant?: "scrollable" }} [props] — use `scrollable` when many tabs (monolith DRS pattern).
 */
export default function ProfileCommon({
  tabs,
  activeTab,
  onTabChange,
  sections,
  hideSectionTitle = false,
  /** When false, only tabs + card are rendered (parent supplies `container mt-4 col-md-10`). */
  wrapMonolithContainer = true,
  tabsVariant,
}) {
  const variant = tabsVariant ?? (tabs.length > 4 ? 'scrollable' : undefined);

  const inner = (
    <>
      <StyledTabs
        value={activeTab}
        onChange={onTabChange}
        variant={variant}
        className={styles.tabs}
        tabs={tabs.map((label, i) => ({ key: `profile-tab-${i}`, label }))}
      />

      {sections.map((section, idx) => (
        <div key={idx} className={styles.card}>
          {!hideSectionTitle ? (
            <Typography
              variant="subtitle"
              component="h3"
              className={styles.header}
            >
              {section.title}
            </Typography>
          ) : null}
          {section.content}
        </div>
      ))}
    </>
  );

  if (!wrapMonolithContainer) {
    return inner;
  }

  return <div className="container mt-4 col-md-10">{inner}</div>;
}
